import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/reusable/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Careers from './pages/Careers';
import Clients from './pages/Clients';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Footer from './components/reusable/Footer';
import ScrollTop from './components/reusable/ScrollTop';
import NotFound from './components/reusable/NotFound';
import ReactGA from 'react-ga';
import Logo from './pages/logo';

// Initialize Google Analytics with your tracking ID
ReactGA.initialize('G-W9YGRZRQ34'); // Replace with your GA tracking ID

// Function to track page views on route change
const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);

  return null;
};

function App() {
  const location = useLocation();

  // Check if the current path is '/logo'
  const isLogoPage = location.pathname === '/logo';

  return (
    <div>
      <ScrollTop />
      
      {/* Render Navbar and Footer only if not on the Logo page */}
      {!isLogoPage && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/logo" element={<Logo />} />
        
        {/* 404 page */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      {!isLogoPage && <Footer />}
    </div>
  );
}

export default App;
